import * as React from 'react';
import cn from 'classnames';

type Props = {
  cy: string;
  modifier?: 'open' | 'close';
  onClick: () => void;
  children: string;
};

const Link = (props: Props) => (
  <button
    type="button"
    data-cy={props.cy}
    onClick={props.onClick}
    className={cn('editor__hours__link', {
      [`editor__hours__link--${props.modifier}`]: props.modifier
    })}
  >
    {props.children}
  </button>
);

export default Link;
